var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import MuiButton from '@material-ui/core/Button';
import React, { forwardRef, useCallback, useLayoutEffect, useMemo, useRef, } from 'react';
import { combineClasses, isRcElement, removeClassName, styled, useForkRef, useTheme, useThemeProps, withDeprecatedCheck, } from '../../../foundation';
import { RcIcon } from '../../Icon';
import { RcIconSizes } from '../../Icon/utils';
import { RcCircularProgress } from '../../Progress';
import { withTooltip } from '../../Tooltip';
import { buttonStyle } from './styles';
import { getButtonIconSize, RcButtonClasses } from './utils';
var _RcButton = forwardRef(function (inProps, ref) {
    var _a, _b;
    var props = useThemeProps({ props: inProps, name: 'RcButton' });
    var childrenProp = props.children, classesProp = props.classes, startIconProp = props.startIcon, endIconProp = props.endIcon, loading = props.loading, loadingMode = props.loadingMode, disabled = props.disabled, IconProps = props.IconProps, size = props.size, color = props.color, CircularProgressProps = props.CircularProgressProps, variant = props.variant, disabledVariant = props.disabledVariant, radius = props.radius, keepElevation = props.keepElevation, rest = __rest(props, ["children", "classes", "startIcon", "endIcon", "loading", "loadingMode", "disabled", "IconProps", "size", "color", "CircularProgressProps", "variant", "disabledVariant", "radius", "keepElevation"]);
    var theme = useTheme();
    var innerRef = useRef(null);
    var buttonRef = useForkRef(innerRef, ref);
    var isPlain = variant === 'plain';
    var isReplace = loadingMode === 'replace';
    var iconSize = getButtonIconSize(size);
    var loadingElm = useMemo(function () {
        if (loading) {
            var progressSize = RcIconSizes[iconSize];
            return (React.createElement(RcCircularProgress, __assign({ size: progressSize, color: "inherit" }, CircularProgressProps)));
        }
        return undefined;
    }, [CircularProgressProps, iconSize, loading]);
    var getCurrIcon = useCallback(function (currIcon) {
        if (isRcElement(currIcon, ['RcIcon']) &&
            currIcon.props.size === RcIcon.defaultProps.size) {
            return React.cloneElement(currIcon, { size: iconSize });
        }
        return currIcon;
    }, [iconSize]);
    var startIcon = useMemo(function () {
        if (loadingElm) {
            switch (loadingMode) {
                case 'prefix':
                    return loadingElm;
                case 'replace':
                    return undefined;
                default:
                    break;
            }
        }
        if (startIconProp) {
            return getCurrIcon(startIconProp);
        }
        // TODO: IconProps will be remove
        if (IconProps) {
            return React.createElement(RcIcon, __assign({ size: iconSize }, IconProps));
        }
        return undefined;
    }, [
        IconProps,
        getCurrIcon,
        iconSize,
        loadingElm,
        loadingMode,
        startIconProp,
    ]);
    var endIcon = useMemo(function () {
        if (loadingElm) {
            switch (loadingMode) {
                case 'suffix':
                    return loadingElm;
                case 'replace':
                    return undefined;
                default:
                    break;
            }
        }
        if (endIconProp) {
            return getCurrIcon(endIconProp);
        }
        return undefined;
    }, [loadingElm, endIconProp, loadingMode, getCurrIcon]);
    var classes = useMemo(function () { return combineClasses(RcButtonClasses, classesProp); }, [classesProp]);
    // * need remove not need MuiButton-iconSizeMedium for icon render correct
    useLayoutEffect(function () {
        removeClassName(innerRef, 'MuiButton-iconSizeMedium');
    });
    return (React.createElement(MuiButton, __assign({ ref: buttonRef, disabled: disabled || loading, variant: isPlain ? undefined : variant, disableRipple: ((_b = (_a = theme === null || theme === void 0 ? void 0 : theme.props) === null || _a === void 0 ? void 0 : _a.MuiButton) === null || _b === void 0 ? void 0 : _b.disableRipple) || isPlain, startIcon: startIcon, endIcon: endIcon, classes: classes }, rest), loading && isReplace ? loadingElm : childrenProp));
});
/** @release */
var RcButton = styled(withDeprecatedCheck(withTooltip(_RcButton), [
    {
        prop: 'IconProps',
        time: '2021-4',
        comment: "@deprecated Icon, please use startIcon with `<RcIcon />` */",
    },
], 'RcButton'))(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), buttonStyle);
RcButton.defaultProps = {
    size: 'large',
    color: 'primary',
    variant: 'contained',
    loadingMode: 'replace',
};
RcButton.displayName = 'RcButton';
export { RcButton, };
var templateObject_1;
